import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=c55e1cb4&scoped=true&"
import script from "./ProgressBar.vue?vue&type=script&lang=js&"
export * from "./ProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./ProgressBar.vue?vue&type=style&index=0&id=c55e1cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55e1cb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\soiko\\Documents\\Projects\\game\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c55e1cb4')) {
      api.createRecord('c55e1cb4', component.options)
    } else {
      api.reload('c55e1cb4', component.options)
    }
    module.hot.accept("./ProgressBar.vue?vue&type=template&id=c55e1cb4&scoped=true&", function () {
      api.rerender('c55e1cb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProgressBar.vue"
export default component.exports